<template>
  <div class="main-block request-management">
    <div class="div col-12 p-0 d-flex align-items-start">
      <h4 class="">{{ $t('title.profile') }}</h4>
    </div>
    <section class="col-12 mx-auto align-self-md-center">
      <div class="half-design row">
        <div class="col-12 form-block">
          <div class="col-12 col-lg-6 mx-auto pt-5">
            <b-form @submit.prevent="handleSubmit">
              <b-row>
                <div class="col-12">
                  <b-row>
                    <div class="col-12 mb-2">
                      <label for="full_name">{{ $t('title.fullName') }}</label>
                      <b-form-input name="full_name" v-model="formFields.full_name" type="text"></b-form-input>
                      <b-form-invalid-feedback :state="!formErrors.has('full_name')">
                        {{ formErrors.first('full_name') }}
                      </b-form-invalid-feedback>
                    </div>

                    <div class="col-12 mb-2">
                      <label for="email">{{ $t('title.email') }}</label>
                      <b-form-input name="email" v-model="formFields.email" type="email"></b-form-input>
                      <b-form-invalid-feedback :state="!formErrors.has('email')">
                        {{ formErrors.first('email') }}
                      </b-form-invalid-feedback>
                    </div>
                  </b-row>

                  <b-row class="mt-3">
                    <div class="col-12 mb-2">
                      <label for="phone">{{ $t('title.phone') }}</label>
                      <vue-tel-input name="phone" v-model="formFields.phone" />
                      <b-form-invalid-feedback :state="!formErrors.has('phone')">
                        {{ formErrors.first('phone') }}
                      </b-form-invalid-feedback>
                    </div>

                    <div class="col-12 mb-2">
                      <label for="residential_address">{{ $t('title.residentialAddress') }}</label>
                      <input type="text" v-model="formFields.residential_address" @input="search('residential_address')"
                        @focus="onFocus('residential_address')" placeholder="Search location..."
                        class="autocomplete-input form-control" />
                      <ul class="autocomplete-list">
                        <li v-for="(suggestion, index) in dropdowns.addresses.residential_address" :key="index"
                          @click="selectSuggestion(suggestion, 'residential_address')">
                          <span v-if="suggestion.id == 'default'">
                            <b-spinner small variant="primary" type="grow" label="Loading..."></b-spinner>
                          </span>
                          {{ suggestion.label }}
                        </li>
                      </ul>
                      <b-form-invalid-feedback :state="!formErrors.has('residential_address')">
                        {{ formErrors.first('residential_address') }}
                      </b-form-invalid-feedback>
                    </div>
                  </b-row>

                  <b-row class="mt-3">
                    <div class="col-12 mb-2">
                      <label for="client_id">Client ID</label>
                      <b-form-input name="client_id" type="text" value="456789234" readonly></b-form-input>
                      <b-form-invalid-feedback :state="!formErrors.has('client_id')">
                        {{ formErrors.first('client_id') }}
                      </b-form-invalid-feedback>
                    </div>

                    <div class="col-12 mb-2">
                      <label for="Token_api">Token API</label>
                      <b-form-input name="Token_api" type="text" value="4567uhnsdcsy89qi293ytgbsxao9i"
                        readonly></b-form-input>
                      <b-form-invalid-feedback :state="!formErrors.has('client_id')">
                        {{ formErrors.first('client_id') }}
                      </b-form-invalid-feedback>
                    </div>
                  </b-row>
                </div>
              </b-row>

              <b-row class="mt-3">
                <b-col sm="12" lg="4" class="mb-3 gap-2 d-flex">
                  <b-button type="button" variant="outline-primary" class="col"
                    @click.prevent="onCancel">Cancel</b-button>
                  <b-button type="submit" variant="primary" class="col btn-primary">{{ $t('title.update') }}</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Error from '@/Util/Error';
import { request } from '@/Util/Request';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import destinationMixin from '@/Util/destinationMixin';
import { hasRole } from "@/Util/auth";


const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000);
};

const FORM_STATE = {
  email: null,
  phone: null,
  full_name: null,
  residential_address: null,
  disability_id: null,
  is_phone: 0,
  is_wp: 0,
};

export default {
  mixins: [destinationMixin],
  data() {
    return {
      formFields: { ...FORM_STATE },
      formErrors: new Error({}),
      address: null,

      options: [],
    };
  },
  mounted() {
    this.getProfile();
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    onCancel() {
      this.$router.push({ path: '/' });
    },
    resetError() {
      this.formErrors = new Error({});
    },
    async getProfile() {
      const adminRole = hasRole('admin');

      try {
        const response = await request({
          method: 'get',
          url: adminRole ? `/admin/profile` : `/user/profile`, //`/auth/profile`,
        });

        const { data } = response;

        this.formFields = {
          disability_id: data.disability_id,
          full_name: data.full_name,
          email: data.email,
          phone: data.phone,
          residential_address: data.residential_address,
          is_phone: data.is_phone,
          is_wp: data.is_wp,
        };
      } catch (error) {
        this.notifyError();
      }
    },
    async handleSubmit() {
      this.resetError();

      try {
        const adminRole = hasRole('admin');

        const response = await request({
          method: 'post',
          url: adminRole ? `/admin/profile` : `/user/profile`, //`/auth/profile`,
          data: this.formFields,
        });

        this.showToast(

        );
      } catch (error) {
        this.notifyError();

        if (error.request && error.request.status && error.request.status === 422) {
          this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
          return false;
        }
      }
    },

    showToast() {
      const h = this.$createElement;
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        `${this.$t('title.profile')} ${this.$t('title.updateSuccessfully')}`,
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [h('strong', { class: 'mr-2' }, 'Profile Updated')]
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: 'success',
      });
    },

    handleOutsideClick(event) {
      const isOutside =
        !event.target.closest('.autocomplete-input') && !event.target.closest('.autocomplete-list');
      if (isOutside) {
        Object.keys(this.dropdowns.addresses).forEach(key => {
          this.dropdowns.addresses[key] = [];
        });
        this.activeField = null;
      }
    },
    loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          this.search(searchQuery)
            .then(options => {
              callback(null, options); // Pass the options to the callback
            })
            .catch(error => {
              callback(error, []); // Handle errors and pass an empty array
            });
        });
      }
    },
  },
};
</script>
